import React from 'react'
import { connect } from 'react-redux'
import { Checkbox, Form } from 'semantic-ui-react'
import { LKButton as LKBaseButton, LKTextArea } from 'loankeeper-common/components'
import mapValues from 'lodash/mapValues'
import LKModal, { actions as LKModalActions, LKModalContainer, LKModalTrigger } from 'shared/LKModal'
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import translate, { translateWebMessages, translateLKMessage } from '../../translator'
import { actions } from '../../../DetailsContainer'
import { addToBlacklist } from 'src/store/client'
import { writeOff } from 'src/store/loan'

const container = connect(undefined, (dispatch, ownProps) => ({
  openErrorDialog: (message) => dispatch(LKModalActions.openError(message)),

  close: () => dispatch(LKModalActions.close('LOAN_WRITE_OFF')),

  fetchBase: () => dispatch(actions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'base' })),

  addToBlacklist: (params) => dispatch(addToBlacklist(params)),

  writeOff: (params) => dispatch(writeOff(params)),
}))

const getInitialState = () => {
  const values = {
    Comment: '',
    Comment2: '',
    writeoffblacklist: false,
  }

  const state = {
    dirty: false,
    submitting: false,
    values,
    touched: mapValues(values, () => false),
    errors: mapValues(values, () => ''),
  }

  return state
}

@withConstantPermissions('BLACKLIST_CLIENT')
class LoanWriteOffModal extends React.PureComponent {
  state = getInitialState()

  validate = () => ({
    Comment: '',
    Comment2: '',
    writeoffblacklist: '',
  })

  handleChange = (e, { name, type, value, checked }) => {
    this.setState((state) => {
      const values = { ...state.values, [name]: type === 'checkbox' ? checked : value }

      return {
        values,
        errors: this.validate(values),
        touched: { ...state.touched, [name]: true },
      }
    })
  }

  handleBlur = ({ target: { name } }) => {
    this.setState((state) => ({
      errors: this.validate(state.values),
      touched: { ...state.touched, [name]: true },
    }))
  }

  hasError = (name) => this.state.errors[name] && (this.state.touched[name] || this.state.dirty)

  handleSubmit = async () => {
    const { fetchBase, openErrorDialog, close, ID, hash, ClientID, clientHash } = this.props
    const { values } = this.state
    const errors = this.validate(values)
    const valid = Object.keys(errors).every((p) => !errors[p])
    this.setState({ dirty: true, submitting: valid, errors })

    if (!valid) return

    try {
      // const data = await Loan.writeOff({
      //   LoanID: ID,
      //   HashSum_LoanID_: hash,
      //   Comment: values.Comment,
      //   Comment2: values.Comment2,
      //   writeoffblacklist: values.writeoffblacklist ? 1 : 0,
      // })
      //UPDATED API REQUEST loan_oper_api page:writeoff
      const data = await this.props.writeOff({
        LoanID: ID,
        HashSum_LoanID_: hash,
        Comment: values.Comment,
        Comment2: values.Comment2,
        writeoffblacklist: values.writeoffblacklist ? 1 : 0,
      })
      if (!writeOff.fulfilled.match(data)) {
        throw { Error: { Message: data.payload } }
      }
      if (values.writeoffblacklist && (!data.Error || data?.Error?.Code === 0)) {
        // await Client.addToBlackList(ClientID, clientHash, values.Comment)
        //UPDATED API REQUEST client_oper_api page: blacklist
        const res = await this.props.addToBlacklist({
          ClientID: ClientID,
          HashSum_ClientID_: clientHash,
          Comment: values.Comment,
        })
        if (addToBlacklist.rejected.match(res)) {
          throw new Error(res.payload.message)
        }
      }

      fetchBase()
    } catch (e) {
      close()
      openErrorDialog(translateLKMessage(e?.Error?.Message || e?.Error?.Text || e.message))
    } finally {
      close()

      this.setState(getInitialState())
    }
  }

  handleClose = () => {
    this.setState(getInitialState())
  }

  render() {
    const { modalInstanceName } = this.props
    const { submitting, values } = this.state

    return (
      <LKModal
        name={modalInstanceName}
        onClose={this.handleClose}
        heading={translate('cmd_writeoff')}
        size="sm-1"
        footer={
          <LKModal.Footer>
            <LKBaseButton.Okay onClick={this.handleSubmit} loading={submitting} />
          </LKModal.Footer>
        }
      >
        <Form onSubmit={this.handleSubmit}>
          <label>
            {translateWebMessages('WRITEOFF_REASON')}
            <div>
              <LKTextArea
                error={this.hasError('Comment')}
                onBlur={this.handleBlur}
                name="Comment"
                value={values.Comment}
                style={{ width: '100%', marginBottom: '10px' }}
                onChange={this.handleChange}
              />
            </div>
          </label>

          <label>
            {translateWebMessages('WRITEOFF_COMMENT')}
            <LKTextArea
              error={this.hasError('Comment2')}
              onBlur={this.handleBlur}
              name="Comment2"
              value={values.Comment2}
              style={{ width: '100%', marginBottom: '10px' }}
              onChange={this.handleChange}
            />
          </label>

          {this.props.BLACKLIST_CLIENT && (
            <Checkbox
              label={translateWebMessages('chk_add_client_toblacklist')}
              name="writeoffblacklist"
              checked={values.writeoffblacklist}
              onChange={this.handleChange}
            />
          )}
        </Form>
      </LKModal>
    )
  }
}

export const LoanWriteOffModalTrigger = () => (
  <LKModalTrigger name="LOAN_WRITE_OFF" alias="broom">
    {translate('cmd_writeoff')}
  </LKModalTrigger>
)

export default LKModalContainer('LOAN_WRITE_OFF')(container(LoanWriteOffModal))
